import React from "react";

import { useBreakpoint } from "../../../hooks/useBreakpoint";

import { Link } from "../../../utils/customLink";

import { ConditionalSwiper } from "../../../components/shared/conditionalSwiper";
import CardHighlightFeatImage from "../../cards/cardHighlightFeatImage";
import CulturalImmersion from "./culturalimmersion";

import "swiper/css/bundle";
import "swiper/css/navigation";

const FreeTimeAndCulture = ({
  countryExploration,
  weekendTrips,
  localAdventures,
  furtherTravels,
  culturalImmersionDetail,
  culturalPracticesList
}) => {
  const breakpoint = useBreakpoint();
  const conditionalSliderOpts = {
    condition: breakpoint === "xs",
    slidesPerView: 1.15,
    spaceBetween: 10,
    centeredSlides: false,
    className: "w-full h-full"
  };
  return (
    <>
      <div className={""}>
        <h2 className="heading text-left py-5">
          {countryExploration.countryExplorationTitle}
        </h2>
        <div className="divide-y width-divider hidden md:block" />

        {countryExploration?.countryExplorationContent?.length > 0 && (
          <div
            className={
              "dark:gvi-light-gray-text text-black-lighter text-sm my-5 tab-content_html"
            }
            dangerouslySetInnerHTML={{
              __html: countryExploration.countryExplorationContent
            }}
          />
        )}
        {culturalImmersionDetail?.culturalIntroduction?.length > 0 && (
          <div
            className={
              "dark:gvi-light-gray-text text-black-lighter my-5 text-sm tab-content_html"
            }
            dangerouslySetInnerHTML={{
              __html: culturalImmersionDetail?.culturalIntroduction
            }}
          />
        )}
      </div>

      <div className="divide-y width-divider md:hidden" />

      {culturalImmersionDetail && (
        <CulturalImmersion
          details={culturalImmersionDetail}
          culturalPractices={culturalPracticesList}
          conditionalSliderOpts={conditionalSliderOpts}
        />
      )}

      {weekendTrips && weekendTrips.length > 0 && (
        <>
          <div className="md:hidden divide-y width-divider py-4" />
          <h3 className="heading text-left pt-10 mb-4 text-black-lighter dark:font-light">
            {countryExploration.weekendTripsLabel}
          </h3>
        </>
      )}
      <div className="md:grid sm:grid-cols-2 gap-4 dark:gvi-light-gray-text text-sm">
        <ConditionalSwiper {...conditionalSliderOpts}>
          {weekendTrips?.map((item, idx) => (
            <CardHighlightFeatImage
              featuredImage={
                item?.featuredImage?.node?.localFile?.extension
                  ? item?.featuredImage?.node?.localFile
                  : null
              }
              sourceUrl={item?.featuredImage?.node?.sourceUrl}
              desc={item?.content}
              title={item?.title}
              key={`weekendtrip-${idx}`}
              readMoreStatus={"hidden"}
              containerClasses={`sm:mb-6 ${idx === 0 ? "sm:col-span-2" : ""}`}
              hasCollapsibleWrapper={true}
            />
          ))}
        </ConditionalSwiper>
      </div>

      {localAdventures && localAdventures.length > 0 && (
        <>
          <div className="md:hidden divide-y width-divider py-4" />
          <h3 className="heading text-left pt-10 mb-4 text-black-lighter dark:font-light">
            {countryExploration.localAdventuresLabel}
          </h3>
        </>
      )}
      <div className="md:grid sm:grid-cols-2 gap-4 dark:gvi-light-gray-text text-sm">
        <ConditionalSwiper {...conditionalSliderOpts}>
          {localAdventures?.map((item, idx) => (
            <CardHighlightFeatImage
              featuredImage={
                item?.featuredImage?.node?.localFile?.extension
                  ? item?.featuredImage?.node?.localFile
                  : null
              }
              sourceUrl={item?.featuredImage?.node?.sourceUrl}
              desc={item?.content}
              title={item?.title}
              key={`localadventures-${idx}`}
              readMoreStatus={"hidden"}
              containerClasses={`sm:mb-6 ${idx === 0 ? "sm:col-span-2" : ""}`}
              hasCollapsibleWrapper={true}
            />
          ))}
        </ConditionalSwiper>
      </div>

      {furtherTravels && furtherTravels.length > 0 && (
        <>
          <div className="md:hidden divide-y width-divider py-4" />
          <h3 className="heading text-left pt-10 mb-4 text-black-lighter dark:font-light">
            {countryExploration.furtherTravelsLabel}
          </h3>
        </>
      )}
      <div className="md:grid sm:grid-cols-2 gap-4 dark:gvi-light-gray-text text-sm">
        <ConditionalSwiper {...conditionalSliderOpts}>
          {furtherTravels?.map((item, idx) => (
            <CardHighlightFeatImage
              featuredImage={
                item?.featuredImage?.node?.localFile?.extension
                  ? item?.featuredImage?.node?.localFile
                  : null
              }
              sourceUrl={item?.featuredImage?.node?.sourceUrl}
              desc={item?.content}
              title={item?.title}
              key={`furthertravels-${idx}`}
              readMoreStatus={"hidden"}
              containerClasses={`sm:mb-6 ${idx === 0 ? "sm:col-span-2" : ""}`}
              hasCollapsibleWrapper={true}
            />
          ))}
        </ConditionalSwiper>
      </div>

      <Link
        className="text-base font-bold underline text-white mt-6  hidden"
        to="#"
      >
        Read about Speak to alumni next
      </Link>
    </>
  );
};

export default FreeTimeAndCulture;
